import styled from 'styled-components';

import { detailsOneWhenClosedMinusOneWhenOpenVar } from 'components/Details/detailsCssVariables';
import { transition } from 'theme/theme';

export const DropdownChevronHolder = styled.div`
  margin-left: 5px;
  transition: ${transition};
  transform: scaleY(var(${detailsOneWhenClosedMinusOneWhenOpenVar}, 1));
`;
